/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HTTPValidationError, TeamConnectionsResponse } from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listConnectionsApiConnectionsGetResponse200 = {
  data: TeamConnectionsResponse;
  status: 200;
};

export type listConnectionsApiConnectionsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listConnectionsApiConnectionsGetResponseSuccess =
  listConnectionsApiConnectionsGetResponse200 & {
    headers: Headers;
  };
export type listConnectionsApiConnectionsGetResponseError =
  listConnectionsApiConnectionsGetResponse422 & {
    headers: Headers;
  };

export type listConnectionsApiConnectionsGetResponse =
  | listConnectionsApiConnectionsGetResponseSuccess
  | listConnectionsApiConnectionsGetResponseError;

export const getListConnectionsApiConnectionsGetUrl = () => {
  return `/api/connections`;
};

/**
 * S3 source connections assigned to the caller's team.
 * @summary List Connections
 */
export const listConnectionsApiConnectionsGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listConnectionsApiConnectionsGetResponse> => {
  return orvalFetch<listConnectionsApiConnectionsGetResponse>(
    getListConnectionsApiConnectionsGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListConnectionsApiConnectionsGetQueryKey = () => {
  return [`/api/connections`] as const;
};

export const getListConnectionsApiConnectionsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListConnectionsApiConnectionsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>
  > = ({ signal }) =>
    listConnectionsApiConnectionsGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConnectionsApiConnectionsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>
>;
export type ListConnectionsApiConnectionsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListConnectionsApiConnectionsGet<
  TData = Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConnectionsApiConnectionsGet<
  TData = Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConnectionsApiConnectionsGet<
  TData = Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Connections
 */

export function useListConnectionsApiConnectionsGet<
  TData = Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConnectionsApiConnectionsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListConnectionsApiConnectionsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
